export { Dashboard } from './dashboard';
import { Dashboard } from './dashboard';

export function Component() {
  return <Dashboard />;
}
